export default "__VITE_ASSET__D4Rg$MSM__"